import React, { useState } from 'react'
import PropTypes from 'prop-types'
//MUI
import ToggleButton from '@material-ui/lab/ToggleButton'
import ToggleButtonGroup from '@material-ui/lab/ToggleButtonGroup'

export default function FontFormatsTool(props) {
  const { formats, getFormat } = props

  const [myFormats, setMyFormats] = useState(formats)

  const handleFormat = (event, newFormats) => {
    setMyFormats(newFormats)
    getFormat(newFormats)
  }

  return (
    <ToggleButtonGroup style={{ height: 10, width: 60 }} value={myFormats} onChange={handleFormat} aria-label='text formatting'>
      <ToggleButton value='bold' aria-label='bold'>
        B
      </ToggleButton>
      <ToggleButton value='slanted' aria-label='slanted'>
        I
      </ToggleButton>
    </ToggleButtonGroup>
  )
}

FontFormatsTool.propTypes = {
  formats: PropTypes.arrayOf(PropTypes.string).isRequired,
  getFormat: PropTypes.func.isRequired,
}
